<script lang="ts">
  import Layout from './components/Layout.svelte';
</script>

<Layout />
